export default __webpack_public_path__ + "static/media/img-0166-italy-premium-face.d0f51bf0.png";